/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ConsultationContentDto } from '../../models/consultation-content-dto';
import { ConsultationContentReorderDto } from '../../models/consultation-content-reorder-dto';

export interface ConsultationContentAdminControllerReorderV1$Params {
      body: ConsultationContentReorderDto
}

export function consultationContentAdminControllerReorderV1(http: HttpClient, rootUrl: string, params: ConsultationContentAdminControllerReorderV1$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ConsultationContentDto>>> {
  const rb = new RequestBuilder(rootUrl, consultationContentAdminControllerReorderV1.PATH, 'patch');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<ConsultationContentDto>>;
    })
  );
}

consultationContentAdminControllerReorderV1.PATH = '/api/v1/consultation-contents/admin/reorder';
